module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_dress@3x-315c3a490da81897a44e0b2dd576428e.webp";